import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50/70">
      <div className="px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            {/* Brand info */}
            <div className="lg:w-2/5">
              <Link to="/" className="inline-block mb-4">
                <div className="bg-background-50 rounded-md px-3 py-2 inline-block">
                  <img
                    src="https://storage.readdy-site.link/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/e0f500d6-6fff-40ba-a9db-d68c402b3316_compressed_logo-03.webp"
                    alt="財經錢線 Fineline"
                    className="h-8 w-auto"
                  />
                </div>
              </Link>
              <p className="text-sm font-medium text-background-50/80 mb-1">
                財經錢線文化有限公司
              </p>
              <p className="text-xs text-background-50/50 mb-1">
                FINELINE
              </p>
              <p className="text-sm leading-relaxed text-background-50/60 max-w-md mb-4">
                商業理財、心理學與以古諷今類書籍
              </p>
              <p className="text-xs leading-relaxed text-background-50/40 max-w-md mb-3">
                官方網站：
                <a
                  href="https://finline.sonbook.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-background-50/50 hover:text-accent-400 transition-colors"
                >
                  https://finline.sonbook.net/
                </a>
              </p>
              <p className="text-xs leading-relaxed text-background-50/40 max-w-md">
                本品牌委託崧博出版經銷，官方網站由崧博出版製作。
              </p>
            </div>

            {/* Site navigation */}
            <div className="lg:w-1/5">
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-3 tracking-wide">網站導覽</h4>
              <ul className="space-y-2">
                {[
                  { label: '首頁', href: '/' },
                  { label: '品牌介紹', href: '/about' },
                  { label: '合作通路', href: '/stores' },
                  { label: '常見問題', href: '/faq' },
                ].map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* External links */}
            <div className="lg:w-2/5">
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-3 tracking-wide">相關網站</h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="https://sonbook.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    查看崧博出版與經銷品牌
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://catalog.sonbook.net/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm text-background-50/50 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    前往書籍資料庫
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/35">
              &copy; {new Date().getFullYear()} 財經錢線文化有限公司
            </p>
            <p className="text-xs text-background-50/25">
              出版內容為一般知識閱讀，不構成投資建議、金融操作指引、心理治療、心理諮商或政治顧問服務
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}